export default "__VITE_ASSET__vpPoD1R6__"